import React from "react";
import { Alert, Typography } from "@mui/material";

export interface JobListStatusBannerProps {
  hasGdriveFolder: boolean;
  isPolling: boolean;
  canPreProcess: boolean;
  isCompleted: boolean;
  jobsThatCanBeWorked: number;
  sheetTotalItems: number;
  atLeastOneJobMissingImages: boolean;
}

/**
 * Display processing status, completion, or pre-processing prompts
 */
export const JobListStatusBanner: React.FC<JobListStatusBannerProps> = ({
  hasGdriveFolder,
  isPolling,
  canPreProcess,
  isCompleted,
  jobsThatCanBeWorked,
  sheetTotalItems,
  atLeastOneJobMissingImages,
}) => {
  if (isPolling) {
    if (!hasGdriveFolder) {
      return (
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          Loading SKUs...
        </Typography>
      );
    } else {
      return (
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          Processing phase. {jobsThatCanBeWorked} SKUs out of {sheetTotalItems}{" "}
          can be worked.
        </Typography>
      );
    }
  }

  if (canPreProcess && !isPolling) {
    return (
      <Alert
        severity="info"
        sx={{
          textAlign: "center",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {atLeastOneJobMissingImages ? (
          <Typography variant="body1" sx={{ textAlign: "center" }}>
            There is at least one SKU without images. You can start a new
            pre-processing for SKUs without images.
          </Typography>
        ) : (
          <Typography variant="body1" sx={{ textAlign: "center" }}>
            To load the SKUs, start the pre-processing.
          </Typography>
        )}
      </Alert>
    );
  }

  if (isCompleted) {
    return null;
  }

  return null;
};
